import type { ReactNode } from 'react';
import { WarningCircle } from '@phosphor-icons/react';
import { cx } from '../cx';
import { Icon } from '../Icon';

export type ErrorTextProps = {
  id?: string;
  /** Says what went wrong and how to fix it. */
  children: ReactNode;
  /** Announce it (role="alert"); leave off when it sits in a field already wired by aria-describedby. */
  alert?: boolean;
  className?: string;
};

/**
 * One line of error copy: a 3px ink rule, warning icon and semibold words in ink. There is no red or coral in the palette,
 * so the icon and the sentence carry the meaning (MEANING.md, Colour). Field uses it for its error.
 */
export function ErrorText({ id, children, alert, className }: ErrorTextProps) {
  return (
    <p
      id={id}
      role={alert ? 'alert' : undefined}
      className={cx(
        'flex items-start gap-1 border-l-3 border-jc-ink pl-2 text-xs font-semibold text-jc-ink',
        className,
      )}
    >
      <Icon icon={WarningCircle} size="sm" weight="fill" className="mt-px shrink-0" />
      <span className="min-w-0">{children}</span>
    </p>
  );
}
